export const InfoAlert = ({ maxNumberOfSelectedSkills }) => (
  <p className="hint text-danger">
    {translate('You can select a maximum of {{maxNumberOfSelectedSkills}} skills', {
      maxNumberOfSelectedSkills,
    })}
  </p>
);
